import ReservationDetailsModal from './ReservationDetailsModal';
import ExportReservationsModal from './ExportReservationsModal';
import ReservationNotificationEmailModal from './ReservationNotificationEmailModal';
import Scripts from './scripts';

export default {
  ReservationDetailsModal,
  ExportReservationsModal,
  ReservationNotificationEmailModal,
  Scripts,
};
